import { NgModule } from '@angular/core';

import { EviewCoreModule } from '@eview/web';
import { EviewIonicCoreModule } from '@eview/ionic';

@NgModule({
  imports: [EviewCoreModule, EviewIonicCoreModule]
})
export class CoreModule {}
